export const columnFields = [
	'name',
	'email',
	'userGroup',
	'scopeType',
	'inScope',
	'status',
	'createdAt',
	'source',
	'flags.notifications',
	'flags.roles',
	'flags.visibility',
	'flags.chat',
] as const;

export const sortFields = ['name', 'email', 'userGroup', 'createdAt', 'status'] as const;
